import { render, staticRenderFns } from "./AppNotifBar.vue?vue&type=template&id=02a64dca&scoped=true"
import script from "./AppNotifBar.vue?vue&type=script&lang=js"
export * from "./AppNotifBar.vue?vue&type=script&lang=js"
import style0 from "./AppNotifBar.vue?vue&type=style&index=0&id=02a64dca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a64dca",
  null
  
)

export default component.exports